<div class="pill-container">
  <app-pill
    [pillItem]="(searchPill$ | async) ?? undefined"
    [activeCount]="activeSearchCount"
    [selected]="showingSearchBar"
    (clicked)="searchPillClicked.emit()" />
  <app-pill
    *ngIf="showFilterPill"
    [pillItem]="(filterPill$ | async) ?? undefined"
    [activeCount]="activeFiltersCount"
    [selected]="showingFilterWindow"
    (clicked)="filterPillClicked.emit()" />
</div>
